import CircleIcon from '@mui/icons-material/Circle';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  text: string;
  subText?: string | React.ReactNode;
  size?: 'small' | 'medium' | 'large' | 'extra-large';
  color?: string;
  highlight?: boolean;
  disablePadding?: boolean;
}

const PaiListItem: React.FC<Props> = ({ text, subText, color, size = 'medium', highlight, disablePadding }) => {
  const { classes } = useStyles({ size, highlight, disablePadding });
  return (
    <ListItem className={classes.listItem}>
      <ListItemIcon className={classes.listItemIcon}>
        <CircleIcon className={classes.listItemIconDot} sx={{ color: color }} />
      </ListItemIcon>
      <ListItemText className={classes.listItemText} primary={text} secondary={subText} />
    </ListItem>
  );
};

const useStyles = makeStyles<{ size?: 'small' | 'medium' | 'large' | 'extra-large'; highlight?: boolean; disablePadding?: boolean }>()(
  (theme, { size, highlight, disablePadding }) => ({
    listItem: {
      alignItems: 'flex-start',
      padding: 0,
      paddingLeft: 0,
      marginBottom: disablePadding ? 0 : '8px',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    listItemIcon: {
      color: theme.palette.primary.main,
      minWidth: 0,
      marginRight: '8px',
      marginTop: '5px',
    },
    listItemIconDot: {
      fontSize: theme.typography.pxToRem(size === 'small' ? 6 : size === 'medium' ? 8 : size === 'large' ? 10 : size === 'extra-large' ? 12 : 8),
    },
    listItemText: {
      margin: 0,
      '& .MuiListItemText-primary': {
        fontSize: theme.typography.pxToRem(size === 'small' ? 11 : size === 'medium' ? 12 : size === 'large' ? 13 : size === 'extra-large' ? 15 : 12),
        lineHeight: 1.5,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        color: highlight ? theme.palette.primary.main : undefined,
        fontWeight: highlight ? 'bold' : undefined,
      },
      '& .MuiListItemText-secondary': {
        fontSize: theme.typography.pxToRem(size === 'small' ? 11 : size === 'medium' ? 12 : size === 'large' ? 13 : size === 'extra-large' ? 15 : 12),
        marginTop: '2px',
        lineHeight: 1.5,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        color: theme.palette.greys.medium,
      },
    },
  })
);

export default PaiListItem;
